import React from "react"
import HelpTemplate from "../../templates/help"

export default () => <HelpTemplate />
